import { z } from 'zod';

/**
 * Configuration du front, validée au chargement du bundle.
 *
 * Seules les variables préfixées `VITE_` sont exposées par Vite au navigateur.
 * ⚠️ Tout ce qui est déclaré ici est **public** : il est lisible dans le code
 * source livré. Aucun secret (clé API, token de service) ne doit y figurer.
 */
const envSchema = z.object({
  /**
   * Origine de l'API. Vide par défaut : les appels partent alors en relatif sur
   * l'origine du front, routés par le proxy Vite en dev et par le reverse proxy
   * en production. Les cookies restent ainsi first-party.
   */
  VITE_API_BASE_URL: z.string().default(''),
  VITE_API_PREFIX: z.string().startsWith('/').default('/api/v1'),
  VITE_APP_NAME: z.string().min(1).default('ubeefy'),
});

const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
  const details = parsed.error.issues
    .map((issue) => `  • ${issue.path.join('.')} : ${issue.message}`)
    .join('\n');

  throw new Error(`Configuration d'environnement invalide :\n${details}`);
}

export const env = parsed.data;

/** Racine des appels API : `<origine><préfixe>`. */
export const apiUrl = `${env.VITE_API_BASE_URL}${env.VITE_API_PREFIX}`;

export const isDevelopment = import.meta.env.DEV;
